import { Stack } from '@mui/material';
import type { DatePickerProps } from '@side/pantry';
import { DatePickerWithEventTracking } from '../DatePicker/DatePickerV2';

interface Props {
  FirstDatePicker: DatePickerProps;
  SecondDatePicker: DatePickerProps;
}

export const DateRangePicker = ({
  FirstDatePicker,
  SecondDatePicker,
}: Props) => {
  const { value: firstDateValue, slotProps: firstDatePickerSlotProps } =
    FirstDatePicker;
  const { value: secondDateValue } = SecondDatePicker;

  return (
    <Stack sx={{ flexDirection: 'row', gap: 2 }}>
      <DatePickerWithEventTracking
        eventContainer="date-range-picker-first"
        maxDate={secondDateValue ?? undefined}
        errorMessage="Invalid date range"
        {...FirstDatePicker}
        slotProps={{
          ...firstDatePickerSlotProps,
          textField: {
            ...firstDatePickerSlotProps?.textField,
          },
        }}
      />

      <DatePickerWithEventTracking
        eventContainer="date-range-picker-second"
        minDate={firstDateValue ?? undefined}
        errorMessage=" " // the error is surfaced on the first date picker
        {...SecondDatePicker}
      />
    </Stack>
  );
};
